import { Link } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';

export default function NotFound() {
  useSEO(
    '页面走丢了 - 一起艹',
    '抱歉，你访问的页面不存在或已被移除，可以返回首页继续浏览娱乐资讯、视频与互动话题。',
    '一起艹,404,页面不存在',
  );

  return (
    <div className="w-full min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-20">
      <span className="font-heading text-[80px] md:text-[120px] leading-none text-primary-500">404</span>
      <h1 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">这个页面走丢了</h1>
      <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md">
        你访问的链接可能已经失效或被移除。别担心，回到首页继续探索精彩内容吧。
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
        <Link
          to="/category/news"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors"
        >
          看最新资讯
        </Link>
      </div>
    </div>
  );
}